import React, { Fragment } from "react";
import {
    RenderKilogramo,
    RenderGramos,
    RenderNumberPercentage,
} from "Utils/renderField/renderReadField";
// borrarIcon
const eliminarIcon = require("assets/img/icons/borrar.png");
// editarIcon
const editarIcon = require("assets/img/icons/editar.png");

/**
 * Componente para renderizar la tabla de DRC
 * @param {object} props propiedades del componente
 * @returns {JSX.Element} componente de tabla de DRC
 */
export const TablaDRC = (props) => {
    const {
        datosDRC,
        SeleccionarDatoDRCParaEditar,
        EliminarDatoDRC,
        isModoAnalisis,
    } = props;

    return (
        <div className="new-table-wrapper my-4">
            <table>
                <thead>
                    <tr>
                        {isModoAnalisis && <th />}
                        <th className="text-right">PESO MUESTRA</th>
                        <th className="text-right">PESO CREPA</th>
                        <th className="text-right">PH1</th>
                        <th className="text-right">PH2</th>
                        <th className="text-right">PH3</th>
                        <th className="text-right">PS1</th>
                        <th className="text-right">PS2</th>
                        <th className="text-right">PS3</th>
                        <th className="text-right">DRC1</th>
                        <th className="text-right">DRC2</th>
                        <th className="text-right">DRC3</th>
                        <th className="text-right">DRC PROMEDIO</th>
                        <th>HORA INGRESO</th>
                        <th>HORA SALIDA</th>
                        <th>LABORATORISTA</th>
                    </tr>
                </thead>
                <tbody>
                    {datosDRC.length === 0 && (
                        <tr>
                            <td
                                colSpan={isModoAnalisis ? 19 : 18}
                                className="text-center"
                            >
                                No hay datos DRC registrados
                            </td>
                        </tr>
                    )}
                    {datosDRC.map((dato_drc, index) => {
                        return (
                            <tr key={index}>
                                {isModoAnalisis && (
                                    <td label="ACCIONES">
                                        <div className="table-actions">
                                            <img
                                                src={eliminarIcon}
                                                alt="Borrar"
                                                title="Borrar"
                                                className="action_img"
                                                onClick={() =>
                                                    EliminarDatoDRC(index)
                                                }
                                            />
                                            <img
                                                src={editarIcon}
                                                alt="Editar"
                                                title="Editar"
                                                nowrap
                                                className="action_img"
                                                onClick={() =>
                                                    SeleccionarDatoDRCParaEditar(
                                                        dato_drc,
                                                        index,
                                                    )
                                                }
                                            />
                                        </div>
                                    </td>
                                )}
                                <td
                                    label="PESO MUESTRA"
                                    className="text-nowrap text-right"
                                >
                                    <RenderKilogramo
                                        value={dato_drc.peso_muestra}
                                    />
                                </td>
                                <td
                                    label="PESO CREPA"
                                    className="text-nowrap text-right"
                                >
                                    <RenderKilogramo
                                        value={dato_drc.peso_crepa}
                                    />
                                </td>
                                <td
                                    label="PESO HUMEDO 1"
                                    className="text-nowrap text-right"
                                >
                                    <RenderGramos
                                        value={dato_drc.peso_humedo_1}
                                    />
                                </td>
                                <td
                                    label="PESO HUMEDO 2"
                                    className="text-nowrap text-right"
                                >
                                    <RenderGramos
                                        value={dato_drc.peso_humedo_2}
                                    />
                                </td>
                                <td
                                    label="PESO HUMEDO 3"
                                    className="text-nowrap text-right"
                                >
                                    <RenderGramos
                                        value={dato_drc.peso_humedo_3}
                                    />
                                </td>
                                <td
                                    label="PS1"
                                    className="text-nowrap text-right"
                                >
                                    <RenderGramos
                                        value={dato_drc.peso_seco_1}
                                    />
                                </td>
                                <td
                                    label="PS2"
                                    className="text-nowrap text-right"
                                >
                                    <RenderGramos
                                        value={dato_drc.peso_seco_2}
                                    />
                                </td>
                                <td
                                    label="PS3"
                                    className="text-nowrap text-right"
                                >
                                    <RenderGramos
                                        value={dato_drc.peso_seco_3}
                                    />
                                </td>

                                <td
                                    label="DRC 1"
                                    className="text-nowrap text-right"
                                >
                                    {dato_drc.drc_promedio_1 ? (
                                        <RenderNumberPercentage
                                            value={parseFloat(
                                                dato_drc.drc_promedio_1,
                                            )}
                                        />
                                    ) : (
                                        "--"
                                    )}
                                </td>
                                <td
                                    label="DRC 2"
                                    className="text-nowrap text-right"
                                >
                                    {dato_drc.drc_promedio_2 ? (
                                        <RenderNumberPercentage
                                            value={parseFloat(
                                                dato_drc.drc_promedio_2,
                                            )}
                                        />
                                    ) : (
                                        "--"
                                    )}
                                </td>
                                <td
                                    label="DRC 3"
                                    className="text-nowrap text-right"
                                >
                                    {dato_drc.drc_promedio_3 ? (
                                        <RenderNumberPercentage
                                            value={parseFloat(
                                                dato_drc.drc_promedio_3,
                                            )}
                                        />
                                    ) : (
                                        "--"
                                    )}
                                </td>
                                <td
                                    label="DRC PROMEDIO"
                                    className="text-nowrap text-right"
                                >
                                    {dato_drc.drc_promedio_total ? (
                                        <RenderNumberPercentage
                                            value={parseFloat(
                                                dato_drc.drc_promedio_total,
                                            )}
                                        />
                                    ) : (
                                        "--"
                                    )}
                                </td>

                                <td
                                    label="HORA INGRESO"
                                    className="text-nowrap"
                                >
                                    <span>{dato_drc.hora_ingreso} </span>
                                </td>
                                <td label="HORA SALIDA" className="text-nowrap">
                                    <span>{dato_drc.hora_salida} </span>
                                </td>
                                <td
                                    label="LABORATORISTA"
                                    className="text-nowrap"
                                >
                                    <span>
                                        {dato_drc.laboratorista_nombre
                                            ? dato_drc.laboratorista_nombre
                                            : dato_drc.laboratorista &&
                                              dato_drc.laboratorista.nombre}
                                    </span>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
